<template>
    <div class="card-body" v-loading="$parentInfo.pastReturnVisit.dialog_PastReturnDetail.loading">
        <el-form ref="$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData">
            <el-form-item label="回访家长的意见：">
                <div v-if=$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.return_visit_opinion>
                    {{$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.return_visit_opinion}}
                </div>
                <div v-else>无</div>
            </el-form-item>
            <el-form-item label="回访家长的态度平分：">
                <el-rate v-model="$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.attribute_id" :disabled=true></el-rate>
            </el-form-item>
            <el-form-item label="回访家长的态度：">
                <div v-if=$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.attributeOpinion>
                    {{$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.attributeOpinion}}
                </div>
                <div v-else>无</div>
            </el-form-item>
            <el-form-item label="备注：">
                <div v-if=$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.remark>
                    {{$parentInfo.pastReturnVisit.dialog_PastReturnDetail.detailData.remark}}
                </div>
                <div v-else>无</div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_PastReturnDetail',
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.pastReturnVisit.dialog_PastReturnDetail.loading = true;
            this.handlePastReturnVisitCheckReturn();
        },
        methods: {
            handlePastReturnVisitCheckReturn() {
                this.$wApi.send(this.$parentInfo.path, 'pastReturnVisitCheckReturn', {
                    'pastReturn_id': this.$store.state.modal.data.id,
                });
            },

        }
    };
</script>

<style scoped>

</style>
